import { __read } from "tslib";
/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx } from '@emotion/core';
import PersonIcon from '@atlaskit/icon/glyph/person';
import ShipIcon from '@atlaskit/icon/glyph/ship';
import { background, N50 } from '@atlaskit/theme/colors';
import { AVATAR_RADIUS, AVATAR_SIZES } from './constants';
var AvatarImage = function (_a) {
    var _b = _a.alt, alt = _b === void 0 ? '' : _b, src = _a.src, appearance = _a.appearance, size = _a.size, testId = _a.testId;
    var _c = __read(useState('initial'), 2), phase = _c[0], setPhase = _c[1];
    var borderRadius = appearance === 'circle' ? '50%' : AVATAR_RADIUS[size] + "px";
    useEffect(function () {
        // check whether there was a problem loading the image
        // if handleLoadError is called we show the default avatar
        var img;
        if (src) {
            setPhase('loading');
            img = new Image();
            img.onload = function () { return setPhase('loaded'); };
            img.onerror = function () { return setPhase('error'); };
            img.src = src;
        }
        return function () {
            if (img) {
                img.onload = function () { };
                img.onerror = function () { };
            }
        };
    }, [src]);
    if (phase === 'loading' || phase === 'error' || !src) {
        return (jsx("span", { css: {
                backgroundColor: N50,
                width: '100%',
                height: '100%',
                display: 'block',
                '& svg': {
                    height: AVATAR_SIZES[size] + "px",
                    width: AVATAR_SIZES[size] + "px",
                },
            } }, appearance === 'circle' ? (jsx(PersonIcon, { label: alt, primaryColor: background(), secondaryColor: N50, testId: testId && testId + "--person" })) : (jsx(ShipIcon, { label: alt, primaryColor: background(), secondaryColor: N50, testId: testId && testId + "--ship" }))));
    }
    return (jsx("span", { css: {
            backgroundColor: 'transparent',
            backgroundImage: "url(" + src + ")",
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: borderRadius,
            display: 'flex',
            flex: '1 1 100%',
            height: '100%',
            width: '100%',
        }, role: "img", "aria-label": alt, "data-testid": testId && testId + "--image" }));
};
export default AvatarImage;
//# sourceMappingURL=AvatarImage.js.map